import { env } from "../../../utils/env";

const { chatIds } = env.graphApiConfig;

const productMapping: { [product: string]: string } = {
  AMMONIA: chatIds.ammonia,
  ATS: chatIds.ats,
  DAP: chatIds.phosphate,
  MAP: chatIds.phosphate,
  PHOSPHATE: chatIds.phosphate,
  SUPERU: chatIds.superu,
  UAN: chatIds.uan,
  UREA: chatIds.urea,
};

export default productMapping;
